import type {
  AudienceMember,
  AudienceMemberData,
  Placement,
} from 'src/types/audience-member';
import type {SenseAction} from 'src/action-creators/types';

import {
  RECEIVE_AUDIENCE_MEMBERS,
  RECEIVE_PLACEMENTS,
} from 'src/action-creators/audience-members/audience-members';
import {RECEIVE_AUDIENCE_MEMBER as RECEIVE_SENT_EVENTS} from 'src/action-creators/sent-events';
import {RECEIVE_INBOX, RECEIVE_THREAD} from 'src/action-creators/messages';
import {RECEIVE_BROADCAST} from 'src/action-creators/broadcasts';
import {RECEIVE_ONE as RECEIVE_THREAD_LIST} from 'src/action-creators/thread-lists';
import {SentEventWithExternals} from 'src/api-parsers/events.types';


export type State = {
  [audienceMemberId: string]: AudienceMemberData;
};

// @ts-expect-error - TS2698 - Spread types may only be created from object types.
const initialState = {...null} as const;

export default (
  state: State | null | undefined = initialState,
  action: SenseAction,
): State => {
  switch (action.type) {
    case RECEIVE_AUDIENCE_MEMBERS: {
      // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State | { [key: string]: AudienceMemberData; }'.
      return reduceAudienceMembers(state, action.payload);
    }

    case RECEIVE_PLACEMENTS: {
      const {placements, audienceMemberId} = action.payload;
      // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State'.
      return reduceData(state, audienceMemberId, {placements});
    }

    case RECEIVE_SENT_EVENTS: {
      const {sentEvents, audienceMemberId} = action.payload;
      // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State'.
      return reduceData(state, audienceMemberId, {
        sentEvents,
      });
    }

    case RECEIVE_BROADCAST:
    case RECEIVE_THREAD_LIST:
    case RECEIVE_INBOX: {
      if (action.payload.audienceMembers) {
        // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State | { [key: string]: AudienceMemberData; }'.
        return reduceAudienceMembers(state, action.payload.audienceMembers);
      }
      break;
    }
    case RECEIVE_THREAD: {
      if (action.payload.response.audienceMembers) {
        return reduceAudienceMembers(
          // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State | { [key: string]: AudienceMemberData; }'.
          state,
          action.payload.response.audienceMembers,
        );
      }
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};

function reduceData(
  state: State,
  audienceMemberId: string,
  update:
    | {
        placements: Array<Placement>;
      }
    | {
        sentEvents: Array<SentEventWithExternals>;
      },
) {
  return {
    ...state,
    [audienceMemberId]: reduceSingleData(state, audienceMemberId, update),
  };
}

function reduceAudienceMembers(
  state:
    | State
    | {
        [key: string]: AudienceMemberData;
      },
  audienceMembers: Array<any> | Array<AudienceMember>,
) {
  state = {...state};

  for (const audienceMember of audienceMembers) {
    state[audienceMember.id] = reduceSingleData(state, audienceMember.id, {
      audienceMember,
    });
  }

  return state;
}

function reduceSingleData(
  state:
    | State
    | {
        [key: string]: AudienceMemberData;
      },
  // @ts-expect-error - TS7006 - Parameter 'audienceMemberId' implicitly has an 'any' type.
  audienceMemberId,
  // @ts-expect-error - TS7006 - Parameter 'update' implicitly has an 'any' type.
  update,
) {
  return {
    ...state[audienceMemberId],
    ...update,
    id: audienceMemberId,
  };
}
